import type { Country } from '@/types/api'
import { createCrudService } from '../crud'

export type CountryInput = Pick<Country, 'code' | 'name_en' | 'name_ru' | 'name_uz' | 'name_cyr' | 'status'>

export const countriesService = createCrudService<Country, CountryInput>('countries')
